module.exports = __webpack_public_path__ + "img/duijian_0.3ffbb3b5.png";